<div *ngIf="paramGroups().length">
  <div *ngIf="enableSearch" class="drive-search row small-gutter">
    <div class="col">
      <input
        [disabled]="disabled"
        [(ngModel)]="search"
        (keydown)="$event.stopPropagation()"
        id="drive-search"
        class="form-control"
        [placeholder]="'SearchADrive' | translate"
      />
      <i class="icon-search"></i>
    </div>
    <div *ngIf="enableFilterOverrides" class="btn-group-toggle col-md-auto" data-toggle="buttons">
      <label
        [class.no-cursor]="disabled"
        [ngClass]="{ active: filterOverrides() }"
        class="btn btn-sm btn-primary form-control"
      >
        <input
          type="checkbox"
          [disabled]="disabled"
          [ngModel]="filterOverrides()"
          (ngModelChange)="filterOverrides.set($event)"
          autocomplete="off"
        />
        {{ 'OnlyOverrides' | translate }}
      </label>
    </div>
  </div>
  <div class="brain-tunable-container custom-scrollbar w-100">
    @for (group of groups; track group.id) {
      <div
        class="group-container transition"
        [ngClass]="{
          disabled: !editMode,
          mask: disabled,
        }"
      >
        <div class="flex-align-items space-between pointer w-100" (click)="toggleOpenGroup(group)">
          <h5>
            <span class="mx-1" [innerHTML]="group.label"></span>
            <span *ngIf="groupsVM.get(group.id).countModifiedDrives > 0" class="count-modified"
              >({{ groupsVM.get(group.id).countModifiedDrives }})</span
            >
          </h5>
          <i
            class="icofont collapse-arrow"
            [ngClass]="[groupsVM.get(group.id).opened ? 'icofont-simple-up' : 'icofont-simple-down']"
          ></i>
        </div>

        @if (groupsVM.get(group.id).opened) {
          @for (drive of group.subGroups; track drive.uid) {
            <div
              class="drive-container"
              [ngClass]="{ modified: subGroupsVM.get(drive.uid).dirty, 'd-none': !driveFilter(drive) }"
            >
              <div class="drive-label">
                <span [innerHTML]="drive.label"></span>
                @if (drive.aggravatingFactor) {
                  <app-help tooltipKey="AggravatingFactorLabel" class="ml-1" />
                }
                <br />
                <span class="little" [innerHTML]="drive.description"></span
                ><span *ngIf="showUids" class="little ml-1">[{{ drive.uid }}]</span>
              </div>
              <div class="drive-parameters-container">
                @for (param of drive.params; track param.uid) {
                  <div class="drive-parameter">
                    @if (showVisibility) {
                      <app-brain-param-visibility [visibility]="param.visibility" />
                    }
                    <label
                      class="input-label"
                      [title]="param.uid + '\n(' + tr.instant('ClickToCopy') + ')'"
                      (click)="copyActorToClipboard(param.uid)"
                      >{{ param.label }}</label
                    >
                    @switch (param.type) {
                      @case ('toggleButton') {
                        <app-switch
                          [defaultValue]="param.recommendedValue !== 0"
                          [(ngModel)]="brainOverrides()[param.uid]"
                          [disabled]="!editMode"
                          [highlightActiveLabel]="
                            brainOverrides()[param.uid] !== null && brainOverrides()[param.uid] !== undefined
                          "
                        />
                      }
                      @case ('input') {
                        @let isNumber =
                          brainOverrides()[param.uid] !== '' &&
                          brainOverrides()[param.uid] !== null &&
                          brainOverrides()[param.uid] !== undefined;
                        <input
                          id="{{ param.uid }}"
                          (keyup)="onInputChange($event.target, param)"
                          [(ngModel)]="brainOverrides()[param.uid]"
                          [disabled]="!editMode"
                          [placeholder]="param.recommendedValue"
                          [ngClass]="{
                            overridden: isNumber && !modified.has(param.uid),
                            modified: isNumber && modified.has(param.uid),
                            error: errors.has(param.uid),
                          }"
                          class="form-control form-control-sm value"
                        />
                        <small class="min-max"
                          >{{ 'min' | translateLabel }}&nbsp;{{ param.min }} - {{ 'max' | translateLabel }}&nbsp;{{
                            param.max
                          }}</small
                        >
                      }
                    }
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    }
  </div>
</div>
